import { render, staticRenderFns } from "./outter_list.vue?vue&type=template&id=311c83c1&"
import script from "./outter_list.vue?vue&type=script&lang=js&"
export * from "./outter_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports